import { atom } from "jotai";
import { atomWithImmer } from "jotai-immer";
import { Drug } from "views/Visit/RightPanel/NewPrescription/types";

export const selectedDrugsAtom = atomWithImmer<Drug[]>([]);
export const isIssuePrescriptionLoadingAtom = atom(false);
